import {KeyboardDoubleArrowLeft} from '@mui/icons-material';
import {
  IconButton,
  type IconButtonProps,
  Paper,
  type PaperProps,
  type SvgIconProps,
  Tooltip,
  type TooltipProps,
  mergeSlotProps,
} from '@mui/material';
import {FC} from 'react';
import dimensions from '@src/styles/dimensions.ts';

export type PanelToggleButtonProps = {
  expand?: boolean;
  onExpand?: (expanded: boolean) => void;
  rootProps?: PaperProps;
  buttonProps?: IconButtonProps;
  iconProps?: SvgIconProps;
  tooltipProps?: TooltipProps;
};

export const PanelToggleButton: FC<PanelToggleButtonProps> = ({
  expand,
  onExpand,
  rootProps = {},
  buttonProps = {},
  iconProps = {},
  tooltipProps: tooltipPropsWithTitle,
}) => {
  const {title, ...tooltipProps} = tooltipPropsWithTitle ?? {
    title: expand ? 'Collapse panel' : 'Expand panel',
  };
  return (
    <Paper
      elevation={1}
      className="toggle-expand"
      {...mergeSlotProps<PaperProps>(
        {
          sx: theme => ({
            display: 'flex',
            height: dimensions.sidebarTab.height,
            boxShadow: 'none',
            borderRadius: `0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0`,
          }),
        },
        rootProps,
      )}
    >
      <Tooltip title={title} placement="right" arrow {...tooltipProps}>
        <IconButton
          aria-expanded={expand}
          onClick={() => onExpand?.(!expand)}
          {...mergeSlotProps<IconButtonProps>(
            {
              sx: {
                paddingInline: 0.3,
                borderRadius: 0,
                color: expand ? 'action.active' : 'primary.main',
              },
            },
            buttonProps,
          )}
        >
          <KeyboardDoubleArrowLeft
            {...mergeSlotProps<SvgIconProps>(
              {
                sx: {
                  fontSize: '16px',
                  rotate: expand ? 'none' : 'y 180deg',
                },
              },
              iconProps,
            )}
          />
        </IconButton>
      </Tooltip>
    </Paper>
  );
};

export default PanelToggleButton;
